import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track1ARed = ({ state, workState, onLabelClick }) => (
	<g id="Track1ARed" transform="translate(855.000000, 959.000000)" className="track">
		<g id="line"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			 strokeLinecap="round" strokeWidth={tracksWidth}
		>
			<path d="M0.5,0.5 L21.1714,21.3566 C24.4554,24.6736 29.1764,26.1356 33.7604,25.2556 L70.1374,18.2716"/>
			<path
				d="M85.5,16.5 L108.329628,16.1063857 C112.4393,16.0355293 116.549432,16.2181188 120.636631,16.653115 L141.183572,18.8399034 C153.517527,20.1525926 165.499629,23.7484408 176.518303,29.4439128 L208.679374,46.0677349 C218.953767,51.3784934 230.728179,53.0392628 242.070662,50.777544 L256,48 L256,48"/>

			<TrackArrow transform="translate(68.000000, 19.000000) rotate(166.000000) translate(-68.000000, -19.000000) "
									points="72 27 64 19 72 11"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track1ARed')}
			coords="89.000000, 0.000000"
			text="1A"
			textCoordsX="11.1103516"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track1ARed.propTypes = trackPropTypes;

export default Track1ARed;

